import { type Node } from "reactflow";

export const getNodeSearchName = (node: Node) =>
  (node.data?.alias as string) || (node.data?.label as string) || "";

export const nodeMatchesSearchQuery = (node: Node, query: string) => {
  if (node.type === "tempNode") return false;
  if (!query) return true;
  const q = query.trim().toLowerCase();
  const name = getNodeSearchName(node);
  return !!name && `${name} ${node.id}`.toLowerCase().includes(q);
};
